<template>
   <div class="leads-page leads-page-v2">
      <div class="mt-3">
         <LeadV2/>
      </div>
   </div>
</template>

<script>
import LeadV2 from '@/components/Leads/LeadV2.vue';

export default {
	components: {
		LeadV2,
	},
}
</script>
